module.exports = "<app-top-nav></app-top-nav>\n<div class=\"container content\">\n\t<router-outlet class=\"flex-grow\"></router-outlet>\n</div>\n<app-bottom-nav></app-bottom-nav>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main